import React, { Component, Fragment } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';

class Example extends Component {
  constructor(props) {
    super(props);
    const { metodos } = this.props;

    this.state = {
      show: false,
      totalpagado: 0,
      metodos
    }
  }

  componentDidMount() {
    this.resetValue();
  }

  handleClose = () => this.setState({ show: false });
  handleShow = () => {
    this.resetValue();
    this.setState({ show: true, totalpagado: 0 });
  }

  aceptar = () => {
    const { functionClose } = this.props;
    const { metodos } = this.state;
    this.handleClose();
    functionClose(metodos);
  }

  addvalue = (element, { target }) => {
    const pagos = this.state.metodos;
    const { value } = target;
    let newPagado = 0;
    pagos.forEach(pago => {
      if (pago.ID_METODO_PAGO === element.ID_METODO_PAGO) {
        pago.VALOR = value;
        newPagado += (value==="") ? 0 : parseInt(value, 10);
      }else{
        newPagado += (pago.VALOR==="") ? 0 : parseInt(pago.VALOR, 10);
      }
    });
    this.setState({ totalpagado: newPagado });
  }

  addCash = (value) => {
    const intValue = parseInt(value, 10);
    const pagos = this.state.metodos;
    let newPagado = 0;
    pagos.forEach(pago => {
      if (pago.TIPO === 1) {
        const tmpvalue = (pago.VALOR==="") ? 0 : parseInt(pago.VALOR, 10)
        pago.VALOR = ( tmpvalue + intValue);
      }
      newPagado += (pago.VALOR==="") ? 0 : parseInt(pago.VALOR, 10);
    });

    this.setState({ totalpagado: newPagado });
  }

  resetValue = () => {
    const pagos = this.props.metodos;
    pagos.forEach(pago => {
      pago.VALOR = 0;
    });
    this.setState({ metodos: pagos, totalpagado: 0 });
  }

  totalpay = (value) => {
    this.resetValue();
    this.addCash(value);
  }

  render() {
    const { totalpagado } = this.state;
    const { data } = this.props;
    const { metodos } = this.state;
    const cambio = totalpagado - parseInt(Math.round(data.TOTAL_PAGAR), 10);
    const addvalue = this.addvalue;

    return (
      <Fragment>
        <Button disabled={data.TOTAL_PAGAR === 0} onClick={this.handleShow} className="m-3" >Finalizar Documento</Button>

        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>FINALIZAR FACTURA</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table striped bordered hover>
              <tbody>
                <tr>
                  <th colSpan="3"> RESUMEN </th>
                </tr>
                <tr>
                  <th>TOTAL A PAGAR</th>
                  <td colSpan="2">{Math.round(data.TOTAL_PAGAR)}</td>
                </tr>
                <tr>
                  <th rowSpan={metodos.length + 1}>PAGO</th>
                </tr>
                {metodos.map((element, i) => {
                  return (<tr key={'tr' + i}><td key={'td' + i}>{element.DESCRIPCION_METODO_PAGO} </td><td><input type="number" min="0" onChange={(e) => addvalue(element, e)} value={element.VALOR} /> </td></tr>)
                })}

                <tr>
                  <th>CAMBIO</th>
                  <td colSpan="2" className={(cambio >= 0) ? "text-success" : "text-danger"}>{cambio}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="3">
                    <Button onClick={this.resetValue} variant="danger">Borrar</Button>
                    <Button onClick={() => this.addCash(1000)} className="m-1" variant="outline-primary">$1000</Button>
                    <Button onClick={() => this.addCash(2000)} className="m-1" variant="outline-dark">$2000</Button>
                    <Button onClick={() => this.addCash(5000)} className="m-1" variant="outline-success">$5000</Button>
                    <Button onClick={() => this.addCash(10000)} className="m-1" variant="outline-warning">$10000</Button>
                    <Button onClick={() => this.addCash(20000)} className="m-1" variant="outline-danger">$20000</Button>
                    <Button onClick={() => this.addCash(50000)} className="m-1" variant="outline-info">$50000</Button>
                    <Button onClick={() => this.totalpay(Math.round(data.TOTAL_PAGAR))} variant="success">Pago Exacto</Button>
                  </td>
                </tr>
              </tfoot>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose} variant="secondary">Cancelar</Button>
            <Button disabled={!(cambio >= 0)} onClick={this.aceptar} variant="primary">Confirmar</Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

export default Example;